var _circle, _circle2, _circle3, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-share2-icon lucide-share-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 5,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 19,
    r: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.59,
    x2: 15.42,
    y1: 13.51,
    y2: 17.49
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.41,
    x2: 8.59,
    y1: 6.51,
    y2: 10.49
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWhite);
export default __webpack_public_path__ + "static/media/share_white.34a8ba522758e1fb80e2deb10c71eb19.svg";
export { ForwardRef as ReactComponent };